import React from 'react';
import { createRoot } from 'react-dom/client';
import Login from './Login';
import './main.scss';

const root = createRoot(document.getElementById('app')!);
root.render(React.createElement(Login));
